import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz-trans/client';

import Chip from '../Chip';

import MobileLink from './MobileLink';

import styles from './LoggedInMobileButton.module.scss';

const LoggedInMobileButton = ({
  myProfilePath,
  myReferralsPath,
  myPaymentsPath,
  userAreaPath,
  searchPreferencePath,
  logoutPath,
  isTopTenantVariant
}) => (
  <span>
    {isTopTenantVariant ? (
      <a
        data-test="my-profile-mobile"
        href={myProfilePath}
        className={`ga-my-profile ${
          isTopTenantVariant && styles['top-tenant']
        }`}
      >
        <span className={styles['top-tenant__text']}>
          {trans('logout.text.my-profile')}
        </span>
        <Chip.Choice label={trans('top-tenant.become.cta')} />
      </a>
    ) : (
      <MobileLink
        href={myProfilePath}
        trans="logout.text.my-profile"
        className="ga-my-profile"
      />
    )}
    <MobileLink
      href={searchPreferencePath}
      trans="logout.text.search-preference"
      className="ga-search-preference"
    />
    <MobileLink
      href={userAreaPath}
      trans="logout.text.user-area"
      className="ga-user-area"
    />
    <MobileLink
      href={myReferralsPath}
      trans="header.nav.my-referrals.link"
      className="ga-my-referrals"
    />
    <MobileLink
      href={myPaymentsPath}
      trans="header.nav.my-payments.link"
      className="ga-my-payments"
    />
    <MobileLink href={logoutPath} trans="logout.text" />
  </span>
);

LoggedInMobileButton.propTypes = {
  myProfilePath: PropTypes.string.isRequired,
  myReferralsPath: PropTypes.string.isRequired,
  myPaymentsPath: PropTypes.string.isRequired,
  userAreaPath: PropTypes.string.isRequired,
  searchPreferencePath: PropTypes.string.isRequired,
  logoutPath: PropTypes.string.isRequired,
  isTopTenantVariant: PropTypes.bool
};

LoggedInMobileButton.defaultProps = {
  isTopTenantVariant: false
};

export default LoggedInMobileButton;
